<template>
	<vx-card>
		<vs-input
			class="w-full mb-4"
			v-validate="'required'"
			data-vv-validate-on="blur"
			label="Название категории"
			name="Название категории"
			v-model="newCategory.name"
			/>
		<span class="text-danger text-sm">{{ errors.first('Название категории') }}</span>

		<picture-input 
			ref="pictureInput" 
			@change="onChange"
			name="Изображение категории"
			width="200" 
			height="200" 
			margin="1" 
			accept="image/svg,image/svg+xml" 
			size="15" 
			buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
			:prefill="newCategory.image"
			:customStrings="{
				upload: '<h1>Загрузить изображение</h1>',
				drag: 'Загрузите изображение',
				change: 'Изменить изображение',
				remove: 'Удалить изображение',
				select: 'Выбрать изображение',
			}">
		</picture-input>
		<span class="text-danger text-sm">{{ errors.first('Изображение категории') }}</span>

		<vs-button
			@click="createCategory"
			:disabled="!validateForm"
			class="mr-5 vs-con-loading__container"
			ref="loadableButton"
			type="relief"
			vslor="primary"
			>
			Создать
		</vs-button>

	</vx-card>
</template>

<script>
import { API_URL } from '@/.env'
import PictureInput from 'vue-picture-input'

export default {
  data: () => ({
	BASE_URL: API_URL,
	
	newCategory: {
		name: '',
		image: null,
	}
  }),
  components: {
	PictureInput
  },
  watch: {},
  computed: {
	validateForm () {
      return !this.errors.any() && this.newCategory.name !== '' && this.newCategory.image !== null
	},
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
	},
	onChange() {
		this.newCategory.image = this.$refs.pictureInput.file;
	},
	createCategory() {
		this.$load(async () => {
			let res = (await this.$api.services.createCategory(this.newCategory));
			
			if(res.status == 200) {
				let idNewCategory = res.data.id;

				let payload = {
					imageFile: this.newCategory.image
				}

				this.$load(async () => {
					await this.$api.services.updateServicesImage(idNewCategory, payload).then(response => {
						if(response.status == 200) {
							this.notification(
								"Успешно",
								'Категория создана',
								"success"
							);
						}
						else {
							this.notification(
								"Предупреждение",
								'Категоря создана, но изображение не удалось прикрепить',
								"warning"
							);
						}
					});
				});

				this.$router.push({ name: 'services-categories' })
			} else {
				this.notification(
					"Ошибка",
					'Не удалось создать категорию',
					"danger"
          		);
			}
		});
	}
  },
  created() {},
  mounted() {
    
  },
};
</script>